import { getList, getOne } from './getData'
import { setCreate, setDelete, setUpdate } from './setData'

const stadiums = {
  namespaced: true,
  state: {
    loading: false,
    listStadiums: [],
    listSelectStadiums: [],
    idSelected: '',
    stadiumSelected: {}
  },
  mutations: {
    updateList: (state, list) => {
      state.listStadiums = list || []
      state.listSelectStadiums = []
      if (list) {
        let activeList = list.filter(item => item.active)
        activeList.forEach(item =>
          state.listSelectStadiums.push({
            text: item.name,
            value: item._id
          })
        )
      }
    },
    updateOne: (state, one) => {
      state.stadiumSelected = one
      state.idSelected = one._id
    },
    updateLoading: (state, loading) => (state.loading = loading),
    updateClearOne: state => {
      state.stadiumSelected = {}
      state.idSelected = ''
    }
  },
  actions: {
    setInit: async ({ commit }) => await getList(commit),
    setCreateNew: async ({ commit }, stadium) => {
      await setCreate(stadium)
      getList(commit)
    },
    setUpdateStadium: async ({ commit }, stadium) => {
      await setUpdate(stadium)
      getList(commit)
    },
    setDeleteStadium: async ({ commit }, id) => {
      await setDelete(id)
      getList(commit)
    },
    setOne: ({ commit }, id) => getOne(commit, id),
    setClearOne: ({ commit }) => {
      commit('updateClearOne')
    }
  }
}

export default stadiums
